import styles from './CompanyStatusBadge.module.css'

const statuses = {
  verified: ['Verificato', 'positive'],
  active: ['Attivo', 'positive'],
  locked: ['Bloccato', 'neutral'],
  unverified: ['Non verificato', 'warning'],
  suspended: ['Sospeso', 'negative'],
  pending: ['In attesa', 'warning'],
}

export default function CompanyStatusBadge({ status }) {
  const [label, tone] = statuses[status] || [status || 'Non disponibile', 'neutral']
  return <span className={`${styles.badge} ${styles[tone]}`}>{label}</span>
}
